import { Transits } from '@/features/transits/transits';
import { AppLayout } from '@/layouts/app-layout';

function TransitsPage() {
  return (
    <AppLayout>
      <Transits />
    </AppLayout>
  );
}

export default TransitsPage;
